import "../css/theme.css";
import { useTheme } from "../OAS365Theme";

export const useDragAndDropStyle = () => {
  const theme = useTheme();
  const gridStyle = {
    uploadText: useUploadTextStyle(theme),
    uploadTextHighlighted: useUploadTextHighlightedStyle(theme),
    uploadTextSpan: useUploadTextSpanStyle(theme),
    validationStyle: useValidationMessageStyle(theme),
  };
  return gridStyle;
};
const useUploadTextStyle = (theme) => {
  const style = {
    color: theme.colors.subTitle,
    fontFamily: theme.fonts.regular,
    fontSize: theme.fontSizes.normal,
  };
  return style;
};

const useUploadTextHighlightedStyle = (theme) => {
  const style = {
    color: theme.colors.themeDarkColor,
    fontFamily: theme.fonts.regular,
    backgroundColor: "Transparent !important",
  };
  return style;
};

const useUploadTextSpanStyle = (theme) => {
  const style = {
    fontFamily: theme.fonts.regular,
    fontSize: theme.fontSizes.normal,
    color: theme.colors.fontColor,
  };
  return style;
};

const useValidationMessageStyle = (theme) => {
  const style = {
    color: theme.colors.validationColor,
    textAlign: "center",
    fontFamily: theme.fonts.regular,
    fontSize: theme.fontSizes.menusize,
  };
  return style;
};
